<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <PageTitle></PageTitle>
        <b-card>
          <b-row>
            <b-col sm="6">
              <b-form-group>
                <label for="label">{{ $t('page.generic.name') }} <required-field /></label>
                <b-form-input aria-describedby="labelField" :state="errors.some((e) => e.field === 'label')?false:null"
                              type="text" id="label" v-model="category.label" aria-required="true"
                              :required=true></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group>
                <label for="code">{{ $t('page.generic.code') }} <required-field /></label>
                <b-form-input aria-describedby="codeField" :state="errors.some((e) => e.field === 'code')?false:null"
                              type="text" id="code" v-model="category.code" aria-required="true"
                              :required=true disabled></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group>
                <label for="description">{{ $t('page.generic.description') }}</label>
                <b-form-textarea aria-describedby="description" :state="errors.some((e) => e.field === 'description')?false:null"
                                 type="text" id="description" v-model="category.description"></b-form-textarea>
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <button class="btn btn-success float-right padder" type="button" @click="updateCategory">
                {{ $t('actions.save') }}
              </button>
              <router-link class="btn btn-primary float-right" role="button" :to="{name: 'categoryRoute'}">
                {{ $t('actions.abort') }}
              </router-link>
            </b-col>
          </b-row>
        </b-card>
      </b-col>

    </b-row>
  </div>
</template>

<script>
  import miniToastr from 'mini-toastr' //ES6
  import PageTitle from '@/components/PageTitle'
  import CategoryService from '@/services/CategoryService'
  import RequiredField from "../../components/RequiredField";

  const categoryService = CategoryService.build();

  export default {
    name: 'categoryEdit',
    inheritAttrs: false,
    components: {
      RequiredField,
      PageTitle
    },
    props: {
      id: {
        required: true
      }
    },
    data() {
      return {
        category: {},
        errors: []
      }
    },
    created() {
      miniToastr.init(); // config can be passed here miniToastr.init(config)
      miniToastr.setIcon('error', 'i', {'class': 'fas fa-exclamation-triangle'});
      this.fetchData()
    },
    methods: {
      async fetchData() {
        try {
          this.category = await categoryService.read(this.id)
        } catch (exception) {
          exception.errors.forEach(function (element) {
            miniToastr.error(element.message);
          });
        }
      },
      async updateCategory() {
        try {
          await categoryService.update(this.category)
          this.$router.push({name: 'categoryShowRoute', params: {id: this.id}})
          miniToastr.info("Categoria aggiornata con successo");
        } catch (exception) {
          this.errors = exception.errors
          exception.errors.forEach(function (element) {
            miniToastr.error(element.message);
          });
        }

      }
    }
  }
</script>

